const publicPath = (process.env.NODE_ENV === 'production')
    ? process.env.REACT_APP_PUBLIC_PATH || window.location.origin + '/'
    : 'https://localhost:3000/'
// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = publicPath
